import { AxiosInstance } from "axios"
import { SubscriptionOrder } from "../../../../company/reports/accounting/subscriptions/subscriptionsTypes"
import { MerchantSubscriptions } from "./subscriptionTypes"

export enum SupplierSubscriptionQuery {
    SUBSCRIPTIONS_FOR_SUPPLIER_REPORTS = "subscriptions-for-supplier-reports",
    SUBSCRIPTIONS_TYPES_FOR_SUPPLIER = "subscriptions-types-for-supplier",
}

type SubscriptionsForSupplierParams = Readonly<{
    supplierId: number
    orderId?: string
    subscriptionIds?: string
    startDate?: string
    endDate?: string
    merchantId?: string
    merchantIds?: string
    shopIds?: string
    customerId?: string
    userGroupId?: string
    email?: string
    paymentMethods?: string
    creditCardLast4?: string
}>

export type SubscriptionsForSupplierResponse = Readonly<{
    orders: SubscriptionOrder[]
}>

export async function fetchSubscriptionsForSupplier(
    params: SubscriptionsForSupplierParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SubscriptionsForSupplierResponse> {
    const { supplierId, ...rest } = params
    const url = `/supplier/${supplierId}/accounting/subscriptions/orders`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}

type SubscriptionsTypesForSupplierParams = Readonly<{
    supplierId: number
    merchantIds?: string
}>

export type SubscriptionsTypesForSupplierResponse = Readonly<{
    merchants: Array<MerchantSubscriptions>
}>

export async function fetchSubscriptionsTypesForSupplierParams(
    params: SubscriptionsTypesForSupplierParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SubscriptionsTypesForSupplierResponse> {
    const { supplierId, ...rest } = params
    const url = `/suppliers/${supplierId}/subscriptionTypes`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}
